export default "__VITE_ASSET__DQmQQGDw__"